import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings__title" }
const _hoisted_2 = {
  key: 0,
  class: "bs-row"
}
const _hoisted_3 = { class: "c-auto mx-auto" }

import { ref, watch } from "vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import Pagination from "@sazka/design-system/src/pagination/ds-pagination.vue";
import { LotteryDrawSpecialPrizeGroup } from "@/lotteries/services/model/lottery-draw-special-prize-group";
import { LotteryDrawSpecialPrize } from "@/lotteries/services/model/lottery-draw-special-prize";
import { useLotteryResults } from "@/lotteries/services/draw-info/pp-results";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";

interface ViewModelItem {
    name: string;
    prizePages: LotteryDrawSpecialPrize[][];
    totalPages: number;
    currentPage: number;
    type: "SFP" | "NFP";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-special-prize-winnings',
  props: {
    lottery: {},
    specialPrizes: {}
  },
  setup(__props: any) {

const props = __props;

const viewModel = ref<ViewModelItem[]>([]);

const resetViewModel = () => {
    viewModel.value = props.specialPrizes.map((specialPrize) => ({
        name: specialPrize.name,
        type: specialPrize.type,
        prizePages: [],
        totalPages: 1,
        currentPage: 1,
    }));
};

resetViewModel();

const { fetchSpecialPrize } = useLotteryResults();

const loadPage = async (prizeGroupIndex: number, pageNumber: number) => {
    const prizeType = viewModel.value[prizeGroupIndex].type;
    Loader.show();
    try {
        const data = await fetchSpecialPrize(props.lottery, prizeType, pageNumber);
        viewModel.value[prizeGroupIndex].prizePages[pageNumber] = data.data[0].prizes;
        viewModel.value[prizeGroupIndex].totalPages = data.pageCount;
    } catch (error) {
        showAlert({
            title: "Něco se pokazilo",
            subText: "Nepodařilo se načíst výhry, zkuste prosím obnovit stránku a zkusit to ještě jednou.",
        });
    } finally {
        Loader.hide();
    }
};

const pageChanged = async (prizeGroupIndex: number, pageNumber: number) => {
    await loadPage(prizeGroupIndex, pageNumber);
    viewModel.value[prizeGroupIndex].currentPage = pageNumber;
};

watch(
    () => props.specialPrizes,
    () => {
        resetViewModel();
        for (let i = 0; i < viewModel.value.length; i++) {
            loadPage(i, 1);
        }
    },
    {
        immediate: true,
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewModel.value, (specialPrize, prizeGroupIndex) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: specialPrize.name
    }, [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(specialPrize.name), 1),
      _createVNode(DsTable, null, {
        default: _withCtx(() => [
          _createVNode(DsRow, null, {
            default: _withCtx(() => [
              _createVNode(DsCell, {
                type: "th",
                "data-test": "table-special-1-1"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Kód sázky")
                ])),
                _: 1,
                __: [0]
              }),
              _createVNode(DsCell, {
                type: "th",
                "data-test": "table-special-2-1"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Výhra")
                ])),
                _: 1,
                __: [1]
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialPrize.prizePages[specialPrize.currentPage], (prize, i) => {
            return (_openBlock(), _createBlock(DsRow, { key: i }, {
              default: _withCtx(() => [
                _createVNode(DsCell, {
                  "data-test": `table-special-1-${i + 2}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(prize.code), 1)
                  ]),
                  _: 2
                }, 1032, ["data-test"]),
                _createVNode(DsCell, {
                  "data-test": `table-special-2-${i + 2}`
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(prize.prize), 1)
                  ]),
                  _: 2
                }, 1032, ["data-test"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 2
      }, 1024),
      (specialPrize.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(Pagination, {
                "total-pages": specialPrize.totalPages,
                "current-page": specialPrize.currentPage,
                "on-click-handler": (pageNumber) => pageChanged(prizeGroupIndex, pageNumber)
              }, null, 8, ["total-pages", "current-page", "on-click-handler"])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}
}

})